import React, { useState,useEffect } from "react";
import classes from "./ChangePassword.module.css";
import eye from "../../Assets/eye.svg";
import eyesoff from "../../Assets/eyesoff.svg";
import axios from "axios";
import { BASE_URL } from "../../Components/API/Api";
import Swal from "sweetalert2";

const ChangePassword = ({ onClose }) => {

  const [new_password, setNewPassword] = useState("");
  const [password_confirmation, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showCurrentPass, setShowCurrentPass] = useState(false);
  const [current_password, setCurrentPassword] = useState("");

  // preload API password if available
  useEffect(() => {
    // Example: simulate API response
    const response = {
      data: { email: "persie@gmail.com", password: "developers1" }
    };

    if (response?.data?.password) {
      setCurrentPassword(response.data.password);
    }
  }, []);


  const handlePasswordChange = async () => {
    if (!current_password || !new_password || !password_confirmation) {
      Swal.fire("Error", "All password fields are required", "error");
      return;
    }
    if (new_password !== password_confirmation) {
      Swal.fire("Error", "New password and confirm password do not match", "error");
      return;
    }
    setLoading(true);

    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${BASE_URL}/v1/change_password`,
        { current_password, new_password, password_confirmation },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.status === 200 && response.data?.status === true) {
        Swal.fire("Success", "Password changed successfully", "success");
        setTimeout(() => {
          window.location.href = "/signin";
        }, 1500);
      } else {
        let errorMsg = "";
        if (typeof response.data?.message === "object") {
          errorMsg = Object.values(response.data.message).flat().join("\n");
        } else {
          errorMsg = response.data?.message || "Password change failed";
        }
        Swal.fire("Error", errorMsg, "error");
      }
    } catch (error) {
      let errorMsg =
        error.response?.data?.message && typeof error.response.data.message === "object"
          ? Object.values(error.response.data.message).flat().join("\n")
          : error.response?.data?.message || error.message || "Something went wrong";

      Swal.fire("Error", errorMsg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent}>
        <div className={classes.modalHeader}>
          <h2>Change Password</h2>
          <button className={classes.closeBtn} onClick={onClose}>×</button>
        </div>

        <div
          className={classes.portned}
          onKeyDown={(e) => e.key === "Enter" && handlePasswordChange()}
        >
          <div className={classes.coprte}>
            <label>Current Password</label>
            <div className={classes.portal}>
              <input
                type={showCurrentPass ? "text" : "password"}
                placeholder="Enter Old Password"
                className={classes.print}
                value={current_password}
                onChange={(e) => setCurrentPassword(e.target.value)}
              />

              <img
                src={showCurrentPass ? eyesoff : eye}
                alt="Toggle visibility"
                className={classes.eye}
                onClick={() => setShowCurrentPass((prev) => !prev)}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>

          <div className={classes.james}>
            <label>New Password</label>
            <div className={classes.portal}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Create a strong password"
                className={classes.print}
                value={new_password}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <img
                src={showPassword ? eyesoff : eye}
                alt="Toggle visibility"
                className={classes.eye}
                onClick={() => setShowPassword((prev) => !prev)}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>

          <div className={classes.james}>
            <label>Confirm New Password</label>
            <div className={classes.portal}>
              <input
                type={showPass ? "text" : "password"}
                placeholder="Confirm Your password"
                className={classes.print}
                value={password_confirmation}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <img
                src={showPass ? eyesoff : eye}
                alt="Toggle visibility"
                className={classes.eye}
                onClick={() => setShowPass((prev) => !prev)}
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>
        </div>

        <button
          className={classes.sign}
          onClick={handlePasswordChange}
          disabled={loading}
        >
          {loading ? <span className={classes.spinner}></span> : "Change Password"}
        </button>
      </div>
    </div>
  );
};

export default ChangePassword;
